/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedContactSupportButton_item = {
    readonly dibsReference: string | null;
    readonly " $refType": "PdpSharedContactSupportButton_item";
};
export type PdpSharedContactSupportButton_item$data = PdpSharedContactSupportButton_item;
export type PdpSharedContactSupportButton_item$key = {
    readonly " $data"?: PdpSharedContactSupportButton_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactSupportButton_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedContactSupportButton_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "dibsReference",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'fa7fd05e2a569986cf3fe8707f915d6a';
export default node;
